import SchedulerProCalendarIntervalModel from '../../SchedulerPro/model/CalendarIntervalModel.js';
/**
 * @module Gantt/model/CalendarIntervalModel
 */
/**
 * This class represents a calendar interval in the Gantt calendar.
 * Every interval can be either recurrent (regularly repeating in time) or static.
 *
 * Please refer to the [calendars guide](#Gantt/guides/basics/calendars.md) for details
 *
 * @extends SchedulerPro/model/CalendarIntervalModel
 *
 * @typings SchedulerPro.model.CalendarIntervalModel -> SchedulerPro.model.SchedulerProCalendarIntervalModel
 */
export default class CalendarIntervalModel extends SchedulerProCalendarIntervalModel {}
CalendarIntervalModel._$name = 'CalendarIntervalModel';